var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as _ from 'lodash';
import { Component, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { finalize } from 'rxjs/internal/operators/finalize';
import { ConfigureVideoNameDto } from '../../../../shared/service-proxies/service-proxies';
import { ElementSettingModalBase } from '../base/element-setting-modal-base';
import { CreateVideoComponent } from './create-video.component';
var VideoSettingComponent = /** @class */ (function (_super) {
    __extends(VideoSettingComponent, _super);
    function VideoSettingComponent(injector, changeDetectorRef, configureVideoService, modalService) {
        var _this = _super.call(this, injector, 'videoSettingModal') || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.configureVideoService = configureVideoService;
        _this.modalService = modalService;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(VideoSettingComponent.prototype, "configureId", {
        get: function () {
            return this.arg.configureId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoSettingComponent.prototype, "data", {
        get: function () {
            return this.arg.data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoSettingComponent.prototype, "selectVideoName", {
        get: function () {
            return this._selectVideoName;
        },
        set: function (v) {
            if (_.isEqual(this._selectVideoName, v)) {
                return;
            }
            this._selectVideoName = v;
            if (v) {
                this.data.videoTag = v.tag;
                this.data.videoType = +v.videoType;
            }
            else {
                this.data.videoTag = undefined;
                this.data.videoType = undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoSettingComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    VideoSettingComponent.prototype.ngOnInit = function () {
        this.active = true;
        this.init(this.arg.model);
    };
    VideoSettingComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        if (!this.staticTabs) {
            this.changeDetectorRef.detectChanges();
        }
        this.staticTabs.tabs[0].active = true;
        this.getConfigureVideoNames();
    };
    VideoSettingComponent.prototype.getConfigureVideoNames = function () {
        var _this = this;
        this.loading = true;
        this.configureVideoService.getConfigureVideoNames(this.configureId)
            .pipe(finalize(function () { return _this.loading = false; }))
            .subscribe(function (response) {
            _this.videoNames = response.items;
            if (_this.videoNames && _this.videoNames.length > 0) {
                if (_this.data.videoTag !== undefined && _this.data.videoTag !== '') {
                    var videoName = _.find(_this.videoNames, function (h) { return h.tag === _this.data.videoTag; });
                    if (videoName) {
                        _this.selectVideoName = videoName;
                    }
                }
            }
            else {
                _this.selectVideoName = undefined;
            }
        });
    };
    VideoSettingComponent.prototype.save = function () {
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(1);
            return;
        }
        this.closeModal(this.data);
    };
    VideoSettingComponent.prototype.createVideo = function () {
        var _this = this;
        var modalRef = this.modalService.show(CreateVideoComponent, {
            initialState: {
                configureId: this.configureId,
                active: true
            },
            backdrop: 'static',
            class: 'video-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                var videoName = new ConfigureVideoNameDto();
                videoName.tag = result.tag;
                videoName.name = result.name;
                videoName.videoType = +result.videoType;
                _this.videoNames.push(videoName);
                _this.videoNames = _this.videoNames.map(function (item) {
                    return item;
                });
                _this.selectVideoName = videoName;
            }
            onClosedSub.unsubscribe();
        });
    };
    VideoSettingComponent.prototype.closeModal = function (data) {
        this.saving = false;
        this.active = false;
        this._onClosed.next(data);
        this._onClosed.complete();
    };
    VideoSettingComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], VideoSettingComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], VideoSettingComponent.prototype, "staticTabs", void 0);
    VideoSettingComponent = __decorate([
        Component({
            selector: 'video-setting',
            styles: [".video-setting { .select-video-name { float: left; width: calc(100% - 90px); } .create-video { width: 62px; } } "],
            template: "<div class=\"video-setting fe-modal-container\"> <form name='videoSettingModal' bs-modal-drag id=\"videoSettingModal\" class=\"configure\" *ngIf=\"active\" #videoForm=\"ngForm\" novalidate (ngSubmit)=\"save()\" (onHidden)=\"onHidden()\"> <div class=\"modal-header fe-modal-header\"> <div class=\"fe-modal-header-title\"> {{lc(\"Video\")}} </div> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"closeModal()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle valueShow\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('GeneralProperty')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"fe-vertical-label\"> <label class=\"fe-vertical-title\">{{lc(\"VideoName\")}}:</label> <div class=\"fe-vertical-component\"> <ng-select class=\"select-video-name\" [items]=\"videoNames\" bindLabel=\"name\" name=\"SelectVideoName\" [(ngModel)]=\"selectVideoName\" [clearable]=\"false\" [placeholder]=\"lc('SelectVideoName')\" [loading]=\"loading\" [loadingText]=\"l('LoadWithThreeDot')\" [notFoundText]=\"l('NoData')\"> <ng-template ng-label-tmp let-item=\"item\"> {{item.name}} </ng-template> </ng-select> <button type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate fe-btn-manage float-left left-margin create-video\" (click)=\"createVideo()\"> {{l(\"Add\")}} </button> </div> </div> </div> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='false'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!videoForm.form.valid\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"closeModal()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> "
        })
    ], VideoSettingComponent);
    return VideoSettingComponent;
}(ElementSettingModalBase));
export { VideoSettingComponent };
